import { DriverRequestType } from "../../../types/types";
import { api } from "../api";

/**
 * updateDriverByCustomer - Function that updates on database an existing driver by id   
 * /drivers/{id}  
 * method PUT 
 * @async-function
 */
const updateDriverByCustomer = async (token: string, id: number, model: DriverRequestType) => {
    const response = await api.put(
        `/drivers/${id}`, {
            ...model
        }, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    );
    return response;
};

export default updateDriverByCustomer;